// Password recovery. Arabic first — the people who need it most are the ones
// reading the Arabic interface.
export const auth = {
  en: {
    forgotLink: "Forgot your password?",
    forgotTitle: "Reset your password",
    forgotIntro: "Enter the email address on your employee record and we will send you a link to set a new password.",
    forgotSubmit: "Send reset link",
    // ONE MESSAGE FOR EVERY OUTCOME. See ForgotPasswordPage for why the
    // conditional is deliberately absent from the wording.
    forgotSent: "If the email is registered with us, a link will reach you within a few minutes.",
    forgotSentNote: "The link works once and expires after 60 minutes. Check your spam folder, and if nothing arrives, ask Ali to send you one.",
    backToSignIn: "Back to sign in",

    resetTitle: "Choose a new password",
    resetIntro: "Set a new password for your account. You will be signed in with it from now on.",
    resetSubmit: "Save new password",
    resetNoToken: "This page needs a reset link. Open the link from your email, or request a new one.",
    resetDone: "Your password has been changed.",
    resetDoneNote: "You have been signed out everywhere, including on this device. Sign in with your new password.",
    requestAnother: "Request a new link",
    confirmPassword: "Confirm new password",
    passwordsDiffer: "The two passwords do not match.",
    passwordRule: "At least 10 characters, and not only numbers.",

    sendResetLink: "Send a password reset link",
    sendResetLinkHint: "Emails this employee a link to set their own password. The link works once and expires after 60 minutes.",
    resetLinkSent: "A reset link was sent to {address}.",
  },
  ar: {
    forgotLink: "نسيت كلمة المرور؟",
    forgotTitle: "إعادة تعيين كلمة المرور",
    forgotIntro: "أدخل البريد الإلكتروني المسجل في ملفك الوظيفي وسنرسل لك رابطاً لتعيين كلمة مرور جديدة.",
    forgotSubmit: "إرسال رابط إعادة التعيين",
    forgotSent: "إذا كان البريد مسجلاً لدينا، سيصلك رابط خلال دقائق.",
    forgotSentNote: "الرابط يعمل مرة واحدة وتنتهي صلاحيته بعد 60 دقيقة. تحقق من مجلد البريد غير المرغوب، وإذا لم يصلك شيء اطلب من علي إرسال رابط لك.",
    backToSignIn: "العودة إلى تسجيل الدخول",

    resetTitle: "اختر كلمة مرور جديدة",
    resetIntro: "عيّن كلمة مرور جديدة لحسابك. ستستخدمها لتسجيل الدخول من الآن.",
    resetSubmit: "حفظ كلمة المرور الجديدة",
    resetNoToken: "تحتاج هذه الصفحة إلى رابط إعادة تعيين. افتح الرابط من بريدك، أو اطلب رابطاً جديداً.",
    resetDone: "تم تغيير كلمة المرور.",
    resetDoneNote: "تم تسجيل خروجك من جميع الأجهزة، بما في ذلك هذا الجهاز. سجّل الدخول بكلمة المرور الجديدة.",
    requestAnother: "طلب رابط جديد",
    confirmPassword: "تأكيد كلمة المرور الجديدة",
    passwordsDiffer: "كلمتا المرور غير متطابقتين.",
    passwordRule: "10 أحرف على الأقل، وليست أرقاماً فقط.",

    sendResetLink: "إرسال رابط تعيين كلمة المرور",
    sendResetLinkHint: "يُرسل للموظف رابطاً ليعيّن كلمة مروره بنفسه. الرابط يعمل مرة واحدة وتنتهي صلاحيته بعد 60 دقيقة.",
    resetLinkSent: "تم إرسال رابط إعادة التعيين إلى {address}.",
  },
} as const;
